import { render, staticRenderFns } from "./usernameForm.vue?vue&type=template&id=4fc987ba&scoped=true"
import script from "./usernameForm.vue?vue&type=script&lang=js"
export * from "./usernameForm.vue?vue&type=script&lang=js"
import style0 from "./usernameForm.vue?vue&type=style&index=0&id=4fc987ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc987ba",
  null
  
)

export default component.exports